// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"7515e533","74":"1c7c3763","453":"dd0a80ec","575":"037407b0"}[chunkId] + ".chunk.js";
};